import { render, staticRenderFns } from "./clientGroup.vue?vue&type=template&id=cdbf33da&scoped=true&"
import script from "./clientGroup.vue?vue&type=script&lang=ts&"
export * from "./clientGroup.vue?vue&type=script&lang=ts&"
import style0 from "./clientGroup.vue?vue&type=style&index=0&id=cdbf33da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbf33da",
  null
  
)

export default component.exports